import { render, staticRenderFns } from "./addArticle.vue?vue&type=template&id=33b9582f&scoped=true"
import script from "./addArticle.vue?vue&type=script&lang=js"
export * from "./addArticle.vue?vue&type=script&lang=js"
import style0 from "./addArticle.vue?vue&type=style&index=0&id=33b9582f&lang=less"
import style1 from "./addArticle.vue?vue&type=style&index=1&id=33b9582f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b9582f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33b9582f')) {
      api.createRecord('33b9582f', component.options)
    } else {
      api.reload('33b9582f', component.options)
    }
    module.hot.accept("./addArticle.vue?vue&type=template&id=33b9582f&scoped=true", function () {
      api.rerender('33b9582f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/articlemanagement/addArticle.vue"
export default component.exports